import {Injectable, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {SpatialCoordinates} from 'smag-commons/cfg/hierarchy';
import GeocoderResult = google.maps.GeocoderResult;


export const googleZoneMap: { zone: string, regions: string[] }[] = [
    {zone: 'CNOR', regions: ['Toscana', 'Marche']},
    {zone: 'CSUD', regions: ['Lazio', 'Abruzzo', 'Campania', 'Umbria']},
    {
        zone: 'NORD', regions: ['Valle d\'Aosta', 'Piemonte', 'Liguria', 'Lombardia',
            'Trentino-Alto Adige', 'Veneto', 'Friuli-Venezia Giulia', 'Emilia-Romagna']
    },
    {zone: 'SARD', regions: ['Sardegna']},
    {zone: 'SICI', regions: ['Sicilia']},
    {zone: 'SUD', regions: ['Molise', 'Puglia', 'Basilicata']},
    {zone: 'CALA', regions: ['Calabria']},
];

/**
 * Api service that deals with SMAG API backend (both REST and WebSocket interfaces are supported).
 */
@Injectable()
export class GoogleApiService implements OnDestroy {

    private destroyed = new Subject<void>();


    constructor() {

    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    public validateAddress(address: string): Promise<GeocoderResult> {
        const geocoder = new google.maps.Geocoder();
        return new Promise<GeocoderResult>((resolve, reject) => {
            geocoder.geocode({address}, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                    resolve(results[0]);
                } else {
                    // show an error if it's not
                    reject(null);
                }
            });
        });
    }

    public async getCoordinates(address: string): Promise<SpatialCoordinates> {
        const result = await this.validateAddress(address);
        return {
            latitude: result.geometry.location.lat(),
            longitude: result.geometry.location.lng()
        };
    }
}


export function getZone(region: string): string {
    for (const item of googleZoneMap) {
        if (item.regions.includes(region)) {
            return item.zone;
        }
    }
    console.error(`Missing zone for: ${region}`);
    return null;
}

